
function assertAgrHasActiveInsData(agr, ins) {
	let insData = agr.data.userData.insData.find(e => e.ins === ins.id);
	if (!insData) throw new Error(`agr is missing insData for ${ins.id}`);
	if (insData.deactivatedOn) throw new Error(`agr has deactivated insData for ${ins.id}`);
}

function assertAgrHasActiveAsoData(agr, aso) {
	if (!agr.data.userData.asoData) throw new Error('agr is missing asoData');
	let asoData = agr.data.userData.asoData.find(e => e.aso === aso.id);
	if (!asoData) throw new Error(`agr is missing asoData for ${aso.id}`);
	if (asoData.deactivatedOn) throw new Error(`agr has deactivated asoData for ${aso.id}`);
}

function getAgrAddressToUseWithGeoPos(agr, siteId, country) {
	if (!agr.data.userData.supData) throw new Error('agr has no supData');
	let supDataCountry = agr.data.userData.supData.find(e => e.country === country.id);
	if (!supDataCountry) throw new Error(`no sup data found for country ${country.id}`);
	let los = supDataCountry.locationsOfSale.find(l => l.id === siteId);
	if (!los) throw new Error(`no site found with id ${siteId}`);
	let addr = JSON.parse(JSON.stringify(los.address));
	if (!(addr.geoPosition && addr.geoPosition.lat)) {
		throw new Error(`unable to find geo position for this agr ${agr.id} at site ${siteId}`);
	}
	addr.controlNumber = agr.data.userData.controlNumber;
	return addr;
}

module.exports = {
	assertAgrHasActiveInsData,
	assertAgrHasActiveAsoData,
	getAgrAddressToUseWithGeoPos
};
